export default __webpack_public_path__ + "static/media/image-gallery.89c8d270.png";